<script>
import FormItem from 'element-ui/lib/form-item';

export default FormItem;
</script>

<style lang="scss">
@import '../../stylesheets/element-theme/form-item.css';

// Adding RTL support to element's form-item

.el-form-item {
  $form-item: &;

  &__content {
    line-height: inherit;
  }

  &--inline {
    #{$form-item}__label,
    #{$form-item}__content {
      display: inline-block;
      vertical-align: middle;
      float: none;
    }
  }

  &__help {
    margin: 0.5rem auto auto;

    font-size: $small-font-size;
    line-height: 1.5;
    color: $dark-gray;
    @each $key, $value in $foundation-palette {
      &--#{$key} {
        color: $value;
      }
    }
  }

  &__error {
    position: static;
    top: auto;
    left: auto;

    font-size: $small-font-size;
    line-height: normal;
    color: $pomegranate;
  }

  &__label {
    @include rtl() {
      text-align: right;
      float: right;
      padding-right: 0;
      padding-left: 12px;

      &::before {
        margin-left: 4px;
        margin-right: 0;
      }
    }

    .el-form--label-top & {
      float: none;
    }
  }

  input {
    font-family: $lb-body-en-font-family;
  }

  &.is-fullwidth {
    #{$form-item}__label {
      width: 100%;
      padding: 0;
    }
  }
}
</style>
